import {
    de,
    enUS,
    fr,
    it,
    ptBR
} from 'date-fns/locale'; // TODO(date-fns)
import type { Locale } from 'date-fns';

export const localeSwitcher = (code: string): Locale => ({
    de: de,
    fr: fr,
    it: it,
    pt: ptBR
}[code] || enUS);
